const shortDateWithoutYear = 'DD.MM'
const onlyDateWithShortYear = 'DD.MM.YY'
const onlyDateWithFullTear = 'DD.MM.YYYY'
const fullDateWithTime = 'DD.MM.YYYY HH:mm'
const fullDateWithTimeIn = 'DD.MM.YYYY [в] HH:mm'
const defaultDate = 'YYYY-MM-DD'
const defaultDateRu = 'DD-MM-YYYY'
const defaultDateRuFull = 'DD-MM-YYYY HH:mm:ss'
const dateForFileName = 'DD_MM_YYYY'
const respStatusDate = 'DD.MM [в] HH:mm'
const defaultDatePickerFormat = 'YYYY-MM-DD HH:mm:ss'

const nameDay = ['день', 'дня', 'дней']

export {
  defaultDateRuFull,
  shortDateWithoutYear,
  onlyDateWithShortYear,
  onlyDateWithFullTear,
  fullDateWithTime,
  defaultDate,
  defaultDateRu,
  respStatusDate,
  fullDateWithTimeIn,
  defaultDatePickerFormat,
  dateForFileName,
  nameDay,
}
